import Container from './styles'

export default function Header() {
  return (
    <Container>
      <div className="content">
        <img src="/assets/images/logo.png" alt="PrimeDB" />
      </div>
    </Container>
  )
}
